import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { format } from 'date-fns';
import { Action } from '@/lib/types';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface ChartComponentProps {
  label: string;
  actions: Action[];
  height?: number;
}

const LineChart: React.FC<ChartComponentProps> = ({ label, actions, height = 180 }) => {
  const chartData = React.useMemo(() => {
    const dates =
      actions.length > 0
        ? actions.map((item) => format(new Date(item.action_date), 'MMM d'))
        : [''];
    const counts = actions.length > 0 ? actions.map((item) => item.cnt) : [0];

    return {
      labels: dates,
      datasets: [
        {
          label: `${label} Counts`,
          data: counts,
          fill: false,
          backgroundColor: '#3182ce',
          borderColor: '#3182ce',
          borderWidth: 1,
        },
      ],
    };
  }, [actions, label]);

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        intersect: false,
        borderColor: '#ddd',
        borderWidth: 1,
        backgroundColor: '#ffffff',
        titleColor: '#4A5568',
        bodyColor: '#4A5568',
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      y: {
        grid: {
          display: false,
        },
        min: 0,
        max: Math.max(...chartData.datasets[0].data),
        ticks: {
          callback: function (value: any) {
            const min = 0;
            const max = Math.max(...chartData.datasets[0].data);
            if (value === min || value === max) {
              return value;
            }
            return;
          },
        },
      },
    },
  };

  return (
    <div style={{ height }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default LineChart;
